import { Component, ElementRef, HostListener, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { ActivatedRoute, ParamMap, Router } from '@angular/router';
import { ClienteModel } from 'src/app/models/cliente';
import Swal from 'sweetalert2';
import { environment } from 'src/environments/environment';
import { DatosGeneralesModel } from 'src/app/models/datosGenenrales';
import { InfoArrend } from 'src/app/interfaces/info-arrend';
import { OrquestadorService } from 'src/app/services/orquestador/orquestador.service';
import { ResponseServices } from 'src/app/interfaces/response-services';
import { BodyPolizas } from 'src/app/interfaces/body_Polizas';
import { ResponsePolizas } from 'src/app/interfaces/response_Polizas';
import { DataLayerService } from 'src/app/services/dataLeyer/data-leyer.service';
import { BodyHomeNo } from 'src/app/interfaces/body_homeno';
import { InfoArrendNo } from 'src/app/interfaces/InfoArrendNo';
import { COTIZACION_PAUSA, INFO_ARRENDAMIENTOS_NO_IQ, TIEMPO_INACTIVO } from 'src/app/routes.constants';

@Component({
  selector: 'app-homeno',
  standalone: false,
  templateUrl: './homeno.component.html',
  styleUrl: './homeno.component.scss'
})
export class HomenoComponent implements OnInit, OnDestroy {
  botonDesactivado: boolean = false;

  @ViewChild('nombreCliente') nombreCliente!: ElementRef;
  @ViewChild('numCelular') numCelular!: ElementRef;
  @ViewChild('flexCheckAutoriza') flexCheckAutoriza2!: ElementRef;

  // Tiempo local de renovación 
  localTimer = environment.LOCAL_TIMER
  // Cuanta las veces que es invocado el servicio de refrescado de token
  countRefresh = 0;
  // Verifica si hay actividad
  isActivity = false;
  checador: any;
  saliendo: boolean = false;
  isMouseMove: any;
  sessionId: string = '';
  leadId: string = '';
  responsePoliza!: ResponsePolizas;

  @HostListener('document:mousemove', ['$event'])
  onMouseMove(e: MouseEvent) {
    let posicionX, posicionY, nuevaPosicionY, nuevaPosicionX;
    this.isActivity = true;
    nuevaPosicionX = e.clientX;
    nuevaPosicionY = e.clientY;

    if (this.isActivity && (nuevaPosicionX !== posicionX || nuevaPosicionY !== posicionY)) {
      clearTimeout(this.checador);
      this.checador = setTimeout(() => {
        if (this.formulario.get("nombreCliente")?.value !== '' &&
          this.formulario.get("numCelular")?.value !== '') {

          this.isActivity = false;
          this.saliendo = true;
          clearInterval(this.isMouseMove);
          clearTimeout(this.checador);
          this.datosClienteHome.nombreCliente = this.formulario.get("nombreCliente")?.value;
          this.datosClienteHome.celularCliente = this.formulario.get("numCelular")?.value;
          this.datosGenerales.Cliente = this.datosClienteHome;

          this.parametro = JSON.stringify(this.datosGenerales);

          this.router.navigate([TIEMPO_INACTIVO, { codigoAsesor: this.codasesor, porcPll: '5', msnPll: 'Inactividad en llenar datos  flujo sin inquilino', infoViaje: btoa(this.parametro), bitacoraId: this.IdBitacora }]);  
        }
      }, this.localTimer);
    }

    posicionX = e.clientX;
    posicionY = e.clientY;
  }

  private datosClienteHome: ClienteModel = {
    cedulaCliente: '',
    celularCliente: '',
    nombreCliente: '',
    tipoIdentificacion: ''
  };

  private datosGenerales: DatosGeneralesModel = {
    Cliente: {
      cedulaCliente: '',
      celularCliente: '',
      nombreCliente: '',
      tipoIdentificacion: ''
    },
    InfoArrendamiento: {
      tipoPropiedad: '',
      ubicacion: '',
      valorAdministracion: 0,
      valorArriendo: 0,
      fechaContrato: '',
      duracionContrato: '',
      ServiciosPublicos: false,
      PaquetesAsistencia: false
    },
    Propietario: {
      primerNombre: '',
      segundoNombre: '',
      primerApellido: '',
      segundoApellido: '',
      paisNacimiento: '',
      tipoIdentificacion: '',
      numeroIdentificacion: '',
      fechaExpedicion: '',
      correo: ''
    },
    PlanSeleccionado: {
      plan: '',
      valorPlan: 0
    },
    Inmueble: {
      ciudad: '',
      direccion: '',
      maticula: ''
    },
    Inquilino: {
      primerNombre: '',
      segundoNombre: '',
      primerApellido: '',
      segundoApellido: '',
      numCelular: '',
      correo: '',
      paisNacimento: '',
      fechaNacimento: '',
      tipoidentificacion: '',
      documentoIdentidad: '',
      fechaExpedicion: '',
      ciudad: '',
      direccion: ''
    },
    ResponseRiesgoConsultable: [
      {
        esRiesgo: false,
        tipoValidacion: '',
        mensajeValidacion: '',
        idRegistroValidacion: ''
      }
    ]
  }

  private envioPoliza: BodyHomeNo = {
    productFamily: "",
    leadRequirement:"",
    productsConfigurationData: {
      PolicyHolder: {
        LastName: '',
        MobilePhone: '',
        PersonalDataAuthorization: false
      },
      Tenant: {
        DocumentNumber: '',
        DocumentType: ''
      }
    }
  }

  private campoValidados: number = 0;
  private parametro: string = '';
  celularPattern = environment.PATTERN_CELULAR;
  ngSelectTI: string = 'C';
  json: string = '';
  jsonFinal: string = '';
  mensajeAlerta: string = '';
  swAlerta: boolean = false;
  id: any;
  IdBitacora: string = '';

  setUtm_campaign: string = '';
  setUtm_content: string = '';
  setUtm_medium: string = '';
  setUtm_source: string = '';

  datosCliente: InfoArrendNo = {
    Set_utm_campaign: '',
    Set_utm_content: '',
    Set_utm_medium: '',
    Set_utm_source: '',
    SessionId: '',
    productFamily: '',
    asesorCode: '',
    screenPercentage: '',
    leadRequirement:'',
    productsConfigurationData: {
      PolicyHolder: {
        LastName: '',
        MobilePhone: '',
        PersonalDataAuthorization: false
      },
      Tenant: {
        DocumentNumber: '',
        DocumentType: 'C'
      }
    }
  };

  response!: ResponseServices;

  formulario: FormGroup = new FormGroup(
    {
      nombreCliente: new FormControl('', [Validators.required, Validators.maxLength(80)]),
      numCelular: new FormControl('', [Validators.required, Validators.minLength(6), Validators.maxLength(10), Validators.pattern(this.celularPattern)]),
      flexCheckAutoriza: new FormControl(false)
    }
  );

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private orquestadorService: OrquestadorService,
    private _dataLayerService: DataLayerService
  ) { }

  getLocalStorage(): number {
    return Number(localStorage.getItem('session_id'))
  }

  @Input() codasesor: string = '';
  @Input() infoCliente?: string;
  @Input() bitacoraId: string = '';

  @Input() utm_campaign?: string = '';
  @Input() utm_content?: string = '';
  @Input() utm_medium?: string = '';
  @Input() utm_source?: string = '';

  ngOnInit(): void {
    clearInterval(this.isMouseMove);
    clearTimeout(this.checador);

    this.sessionId = this.getLocalStorage().toString();
    const paramInfoCliente = this.infoCliente;

    this.setUtm_campaign = sessionStorage.getItem('utm_campaign') || '';
    this.setUtm_content = sessionStorage.getItem('utm_content') || '';
    this.setUtm_medium = sessionStorage.getItem('utm_medium') || '';
    this.setUtm_source = sessionStorage.getItem('utm_source') || '';

    if (paramInfoCliente !== undefined) {
      this.json = paramInfoCliente;
      this.jsonFinal = atob(this.json);
      this.datosGenerales = JSON.parse(this.jsonFinal);

      this.formulario.get("nombreCliente")?.setValue(this.datosGenerales.Cliente.nombreCliente);
      this.formulario.get("numCelular")?.setValue(this.datosGenerales.Cliente.celularCliente);
    }

    this.route.queryParamMap.subscribe((params: ParamMap) => {
      const resultado = params.get('infoCliente');
      const idLead = params.getAll('idLead')[0];
      this.leadId = idLead || '';
      console.log('this.leadId  ' + this.leadId);

      if (resultado !== null) {
        this.json = resultado;
        this.jsonFinal = atob(this.json);
        this.datosClienteHome = JSON.parse(this.jsonFinal);
      }
    });
  }

  ngOnDestroy() {
    this.saliendo = true;
    clearInterval(this.isMouseMove);
    clearTimeout(this.checador);

    if (this.id) {
      clearInterval(this.id);
    }
  }

  valNombre = false;
  valNombre2 = true;
  validacionNombre() {
    if (this.formulario.get("nombreCliente")?.value === '') {
      this.valNombre = !this.valNombre;
      this.valNombre2 = !this.valNombre2;
    } else {
      this.valNombre = false;
      this.valNombre2 = true;
    }
  }

  valCelular = false;
  valCelular2 = true;
  validacionCelular() {
    if (this.formulario.get("numCelular")?.value === '') {
      this.valCelular = !this.valCelular;
      this.valCelular2 = !this.valCelular2;
    } else {
      this.valCelular = false;
      this.valCelular2 = true;
    }
  }

  get nombreNoValido() {
    return this.formulario.get("nombreCliente")?.invalid
      && this.formulario.get("nombreCliente")?.touched;
  }

  get cedularNoValido() {
    return this.formulario.get("numCelular")?.invalid
      && this.formulario.get("numCelular")?.touched;
  }

  get formularioNoValido() {
    return this.formulario.invalid
  }

  infoArrendamiento(): void {
    this.botonDesactivado = !this.botonDesactivado;
    this.campoValidados = 0;
    if (this.formulario.get("nombreCliente")?.value === '') {
      this.campoValidados = 0;
      Swal.fire('Ingrese el nombre del Cliente', '', 'error');
      this.nombreCliente.nativeElement.focus();
      return;
    }
    else {
      this.campoValidados++;
    }

    if (this.formulario.get("numCelular")?.value === '') {
      this.campoValidados = 0;
      Swal.fire('Ingrese el celular', '', 'error');
      this.numCelular.nativeElement.focus();
      return;
    }
    else {
      this.campoValidados++;
    }

    if (this.campoValidados === 2) {
      this.datosClienteHome.nombreCliente = this.formulario.get("nombreCliente")?.value;
      this.datosClienteHome.celularCliente = this.formulario.get("numCelular")?.value;
      this.datosGenerales.Cliente = this.datosClienteHome
      this.parametro = JSON.stringify(this.datosGenerales);

      this.datosCliente.Set_utm_campaign = this.setUtm_campaign;
      this.datosCliente.Set_utm_content = this.setUtm_content;
      this.datosCliente.Set_utm_medium = this.setUtm_medium;
      this.datosCliente.Set_utm_source = this.setUtm_source;

      this.datosCliente.SessionId = this.sessionId;
      this.datosCliente.productFamily = "Arrendamientos";
      this.datosCliente.screenPercentage = "5";

      if (this.codasesor !== 'undefined') {
        this.datosCliente.asesorCode = this.codasesor;
      }

      if (this.codasesor !== '') {
        this.datosCliente.asesorCode = this.codasesor;
      }
      else {
        this.codasesor = '';
        this.datosCliente.asesorCode = this.codasesor;
      }

      this.datosCliente.productsConfigurationData.PolicyHolder.LastName = this.formulario.get("nombreCliente")?.value;
      this.datosCliente.productsConfigurationData.PolicyHolder.MobilePhone = this.formulario.get("numCelular")?.value.toString();
      this.datosCliente.productsConfigurationData.PolicyHolder.PersonalDataAuthorization = true;
      
      this.datosCliente.leadRequirement = 'Lead Principal sin inquilino';
      this._dataLayerService.logEvent("ecommerce_step_1", "Arrendamiento", "Inicio Arrendamiento sin inquilino", this.sessionId);
      const resquesBody = { ...this.datosCliente, ...(this.leadId !== '' && { leadId: this.leadId }) };

      

      this.orquestadorService.postOrquestadorHomeNo(resquesBody).
        subscribe(
          (data) => {
            this.responsePoliza = data;
            this.IdBitacora = this.responsePoliza.data.bitacoraId === null ? '' : this.responsePoliza.data.bitacoraId;

            this.envioPoliza.productFamily = 'Arrendamiento';
            this.envioPoliza.productsConfigurationData.PolicyHolder.LastName = this.formulario.get("nombreCliente")?.value;
            this.envioPoliza.productsConfigurationData.PolicyHolder.MobilePhone = this.formulario.get("numCelular")?.value.toString();
            this.envioPoliza.productsConfigurationData.PolicyHolder.PersonalDataAuthorization = true;
            this.envioPoliza.leadRequirement = 'Lead Principal sin inquilino';

            if (this.responsePoliza.data.tenant !== true) {
              
              this.router.navigate([INFO_ARRENDAMIENTOS_NO_IQ, { codigoAsesor: this.codasesor, idLead: this.responsePoliza.data.leadId, infoCliente: btoa(this.parametro), bitacoraId: this.IdBitacora }]);
            }
            else {
              this.router.navigate([COTIZACION_PAUSA, { codigoAsesor: this.codasesor, porcPll: '5', msnPll: 'Tipo de Propiedad comercial seleccionada.', idLead: this.responsePoliza.data.leadId, infoCliente: btoa(this.parametro), bitacoraId: this.IdBitacora }]);
            }
          }
        );
    }
  }
}

